import { render, staticRenderFns } from "./EditAttachmentDialog.vue?vue&type=template&id=32036bb2"
import script from "./EditAttachmentDialog.vue?vue&type=script&lang=js"
export * from "./EditAttachmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports